<ng-template
  #content
  let-modal
>
  <div class="modal-header custom-title-modal">
    @if (options().title) {
      <h4
        class="modal-title custom-h4"
        id="modal-basic-title"
      >
        {{ translations.titles[options().title || 'default'] }}
      </h4>
    }
    <ncp-button
      [options]="{
        hostClass: 'btn-close btn-close-white',
        onClick: onClose,
        disabled: options().disableOnSave
      }"
    />
    <!--    <button-->
    <!--      type="button"-->
    <!--      class="btn-close"-->
    <!--      aria-label="Close"-->
    <!--      (click)="close('X button pressed')"-->
    <!--    ></button>-->
  </div>
  <div
    class="modal-body"
    [class.d-flex]="options().type === ModalTypes.empty"
    [class.p-0]="options().type === ModalTypes.empty"
  >
    <!--    @if(options().form) {-->
    <!--      <ng-container-->
    <!--        [ngComponentOutlet]="options().form || null"-->
    <!--        [ngComponentOutletInputs]="{-->
    <!--            data: options().formData,-->
    <!--          }"-->
    <!--        #form="ngComponentOutlet"-->
    <!--      />-->
    <!--    } @else {-->
    <ng-content>{{ translations.messages[options().message || 'default'] }}</ng-content>
    <!--    }-->
  </div>
  @if (options().type !== ModalTypes.info && options().type !== ModalTypes.empty) {
    <div class="modal-footer">
      <div class="d-flex flex-column flex-grow-1">
        @if(options().errors){
          @for (entry of Object.keys(options().errors!); track entry; let i = $index) {
            <div class="error col-12 my-0 py-o fs-6 text-danger"><span>{{i + 1}} - {{translations.validations[entry] || entry}}</span></div>
          }
        }
      </div>
      @if (options().type === ModalTypes.confirm) {
        <ncp-button
          class="align-self-start"
          [options]="{
            text: 'yes',
            class: 'btn-success',
            onClick: onYes,
          }"
        />
      } @else if (options().type === ModalTypes.form) {
        <ncp-button
          class="align-self-start"
          [options]="{
            text: 'reset',
            class: 'btn-secondary',
            onClick: onReset,
            disabled: options().disableOnSave,
            isLoading: options().disableOnSave
          }"
        />
        <ncp-button
          class="align-self-start"
          [options]="{
            text: 'save',
            class: 'btn-primary',
            type: ButtonTypes.submit,
            onClick: onSave,
            formId: options().formId,
            disabled: options().disableOnSave,
            isLoading: options().disableOnSave
          }"
        />
      } @else if (options().type === ModalTypes.alert) {}
    </div>
  }
</ng-template>
